import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const module = {
  namespaced: true,
  state: {
    modules: [],
    defaultModule: null,
    modulesAllowed: []
  },
  getters,
  mutations,
  actions
};
